<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12" class="text-center">
				<div class="nis-score-title">
					<h1>NIS Score - NIS2 Cyber Security</h1>
				</div>
			</v-col>
			<p style="margin: 30px 50px;">
				NIS stands for Network and Information Systems.
				This NIS survey measures your company’s cybersecurity maturity in areas such as
				Governance &amp; Risk Management, Incident Handling &amp; Reporting, Business Continuity
				&amp; Crisis Management, Supply Chain &amp; Third Parties, Technical &amp; Operational
				Security, and People, Training &amp; HR Security, in line with the EU NIS2 Directive
				(the Network and Information Systems Directive).
				You can also view the NIS scores of your suppliers. It’s aligned with key EU
				cybersecurity requirements under NIS2, including risk management, incident reporting,
				and supply-chain security. Additionally, companies can use this assessment to identify
				cybersecurity gaps, improve resilience, and strengthen security practices across their
				entire value chain.
			</p>
			<v-col cols="12">
				<nav class="navi main-nav">
					<ul>
						<li>
							<router-link :to="{ name: 'NIS Your Score' }">YOUR SCORE</router-link>
						</li>
						<li>
							<router-link :to="{ name: 'NIS Connections Score' }">CONNECTIONS SCORE</router-link>
						</li>
					</ul>
				</nav>
			</v-col>
			<router-view />
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "NisScore",
}
</script>

<style scoped>
.nis-score-title h1 {
	font-weight: 500;
}

.navi ul {
	margin: 0;
}

.navi li {
	display: inline;
	padding: 0;
}

.navi a {
	display: inline-block;
	padding: 0.5em;
	font: inherit;
	margin: 10px;
	text-decoration: none;
	font-weight: bolder;
	color: gray;
}

.navi a:hover {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}

.main-nav {
	width: auto;
	text-align: center;
	font-size: 1.2em;
	margin-top: 0;
	padding: 15px 0;
}

a.router-link-active {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}
</style>
